import Image from "next/legacy/image";

import { portfolioData } from "@/components/organisms/LandingPageOrganisms/MktLandingPagePortfolioOraganism/data";
import DesktopDivider from "@/components/atoms/Divider/DesktopDivider/DesktopDivider";

import * as S from "./MktLandingPagePortfolioOraganism.style";
import thumbUp from "public/icons/thumbUp.png";
import trophy from "public/icons/trophy.png";

export default function MktLandingPageMentorOraganism() {
  return (
    <S.Wrapper>
      <S.Top>
        <S.Title>
          업계에서 인정받는
          <br />
          팀스파르타 마케팅 포트폴리오
        </S.Title>
        <S.Desc>
          그로스해킹과 퍼포먼스 마케팅은 물론, 남다른 창의력으로 새로운 시장을
          만들어왔습니다. <DesktopDivider />
          위트를 담은 회자되는 마케팅, 흑자를 이끄는 마케팅의 이면에는 철저한
          전략적 접근이 필수적이었습니다.
        </S.Desc>
        <S.AwardsWrapper>
          <S.Award>
            <Image src={thumbUp} width={15} height={15} alt={"best-practice"} />
            구글, 메타 Best Practice 선정
          </S.Award>
          <S.Award>
            <Image src={trophy} width={15} height={15} alt={"award"} />
            브랜드 대상 2회 수상
          </S.Award>
        </S.AwardsWrapper>
      </S.Top>

      <S.MobileCarouselContainer>
        {portfolioData.map(({ id, img, title, desc, url }) => (
          <S.Slide key={id}>
            <S.Thumbnail>
              <Image
                src={`${process.env.CDN_BASE_URL}/swcamp/${img}.png`}
                width={240}
                height={136}
                alt={"portfolio-thumbnail"}
              />
            </S.Thumbnail>
            <S.ProjectName>{title}</S.ProjectName>

            <S.ProjectDescription>{desc}</S.ProjectDescription>
            {url && (
              <S.ProjectLinkButton href={url} target="_blank">
                사이트 보러가기
              </S.ProjectLinkButton>
            )}
          </S.Slide>
        ))}
      </S.MobileCarouselContainer>
      <S.DesktopCardContainer>
        {portfolioData.map(({ id, img, title, desc, url }) => (
          <S.Slide key={id}>
            <S.Thumbnail>
              <Image
                src={`${process.env.CDN_BASE_URL}/swcamp/${img}.png`}
                width={337}
                height={191}
                alt={"portfolio-thumbnail"}
              />
            </S.Thumbnail>
            <S.ProjectName>{title}</S.ProjectName>

            <S.ProjectDescription>{desc}</S.ProjectDescription>
            {url && (
              <S.ProjectLinkButton href={url} target="_blank">
                사이트 보러가기
              </S.ProjectLinkButton>
            )}
          </S.Slide>
        ))}
      </S.DesktopCardContainer>
    </S.Wrapper>
  );
}
